module.exports = __webpack_public_path__ + "img/turkish_eggs_bread.16133ec8.jpg";